import { useEffect } from "react";

export default function HotelSearchResults() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://www.abengines.com/ui/V2/77A93581/CMBHBTBO5C437514F0404/mt/search-results/";
    script.async = true;
    script.charset = "utf-8";

    const wrapper = document.getElementById("adivaha-wrapper");
    if (wrapper && !wrapper.hasChildNodes()) {
      wrapper.appendChild(script);
    }

    return () => {
      if (wrapper) wrapper.innerHTML = "";
    };
  }, []);

  return <div id="adivaha-wrapper"></div>;
}
